module.exports = __webpack_public_path__ + "img/maiya.a6b1085e.png";